/**
 * C# string formatting.
 * @param format
 * @param args
 */
export function formatString(format: string, args: Array<any>) {
    return format.replace(/{(\d+)}/g, (match, number) => {
        return typeof args[number] != 'undefined'
            ? args[number]
            : match
            ;
    });
}